var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CLink',{staticClass:"btn btn-lg btn-light",class:_vm.active ? 'btn-instagram' : '',on:{"click":function($event){return _vm.setLevel(_vm.level.value)}}},[_vm._v(" "+_vm._s(_vm.level.name)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }